// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"5068f432","488":"0c097a4c","672":"58660fe3"}[chunkId] + ".chunk.js";
};